import React from "react";
import Box from "@mui/material/Box";
import drivePng from "src/assets/images/Drive.png"; // ✅ place your PNG in this folder

const DriveIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={drivePng}
    alt="Drive Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default DriveIcon;
